const InfoBall = ({ icon, label }) => {
  return (
    <div className="info-ball-container">
      <div className="rounded-circle info-ball bg-light-blue d-flex align-items-center justify-content-center">
        {icon()}
      </div>
      <p className="mb-0 text-center">{label}</p>
    </div>
  );
};

export default InfoBall;
